'use client';

import { c as _c } from "react/compiler-runtime";
import * as Headless from '@headlessui/react';
import { CheckCircleIcon, ExclamationCircleIcon, ExclamationTriangleIcon, InformationCircleIcon } from '@heroicons/react/24/outline';
import type React from 'react';
import { cn } from '@/frontend/utils';
import { useDialogVariant } from './Dialog';
const VARIANT_ICONS = {
  warning: ExclamationTriangleIcon,
  success: CheckCircleIcon,
  error: ExclamationCircleIcon,
  info: InformationCircleIcon
} as const;
export interface DialogTitleProps {
  className?: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
}
export const DialogTitle = t0 => {
  const $ = _c(16);
  let children;
  let className;
  let icon;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      icon,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = icon;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    icon = $[3];
    props = $[4];
  }
  const variant = useDialogVariant();
  const Icon = variant === "default" ? null : VARIANT_ICONS[variant];
  let t1;
  if ($[5] !== className) {
    t1 = cn("flex flex-row items-center gap-2 text-balance font-semibold text-base/6 sm:text-lg/6", "[[data-variant=default]_&]:text-contentPrimary", "[[data-variant=warning]_&]:text-contentYellow", "[[data-variant=success]_&]:text-contentGreen", "[[data-variant=error]_&]:text-contentRed", "[[data-variant=info]_&]:text-contentBlue", className);
    $[5] = className;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== Icon || $[8] !== icon) {
    t2 = !icon && Icon && <Icon className="h-6 w-6 shrink-0" />;
    $[7] = Icon;
    $[8] = icon;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const t3 = icon && icon;
  let t4;
  if ($[10] !== children || $[11] !== props || $[12] !== t1 || $[13] !== t2 || $[14] !== t3) {
    t4 = <Headless.DialogTitle {...props} className={t1}>{t2}{t3}{children}</Headless.DialogTitle>;
    $[10] = children;
    $[11] = props;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};